class PartnerTeaser {
    constructor(element) {
        this.oldSliderTransform = 0;

        this.trigger = element.querySelectorAll('.js-partner-teaser-trigger');
        this.content = element.querySelectorAll('.js-partner-teaser-content');
        this.slider = element.querySelector('.js-partner-teaser-slider');

        const [firstContent] = this.content;
        this.currentActiveContent = firstContent;

        const [firstTrigger] = this.trigger;
        this.currentActiveTrigger = firstTrigger;

        this.arrow = element.querySelector('.js-partner-teaser-arrow');

        this.initEvent();

        this.currentActiveContent.classList.add('active');
        this.currentActiveTrigger.classList.add('active');

        if (this.arrow) {
            setTimeout(() => {
                this.arrowSelectorAnimation(this.currentActiveTrigger);
            });
        }
    }

    initEvent() {
        this.trigger.forEach((element, index) => {
            element.addEventListener('click', (event) => {
                event.preventDefault();
                const contentElement = this.content[index];
                this.showContent(contentElement, element);
            });
        });

        if (this.arrow && this.slider) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach(() => {
                    this.arrowSelectorAnimation(this.currentActiveTrigger);
                });
            });

            const target = this.slider;
            observer.observe(target, {attributes: true, attributeFilter: ['style']});
        }
    }

    showContent(content, trigger) {
        if (this.currentActiveContent !== content) {
            // eslint-disable-next-line no-param-reassign
            this.currentActiveContent.classList.remove('active');
            this.currentActiveTrigger.classList.remove('active');

            this.currentActiveContent = content;
            this.currentActiveTrigger = trigger;

            this.currentActiveContent.classList.add('active');
            this.currentActiveTrigger.classList.add('active');
        }

        this.arrowSelectorAnimation(trigger);
    }

    arrowSelectorAnimation(trigger) {
        let {left} = trigger.getBoundingClientRect();
        const width = trigger.clientWidth;
        const offset = 35;
        left = (width / 2) + left - offset;

        if (this.arrow) {
            this.arrow.style.left = `${left}px`;
        }
    }
}

const partnerTeaser = {
    init() {
        const elements = document.querySelectorAll('.js-partner-teaser');

        elements.forEach((element) => {
            this.partnerTeaser = new PartnerTeaser(element);
        });
    },
};

export default partnerTeaser;
